<template>

<div class="divTable">
			<!-- Titre du sous menu -->
			<div  v-bind:class="backgroundColor"  class="divCellLeft hidden-xs-only">
				<div class="rotate">{{column.leftTitle}}</div>
			</div>
			<div   class="divCellTop hidden-sm-and-up">
				<div v-bind:class="backgroundColor" class="border-r" >{{column.leftTitle}}</div>
			</div>

			<div class="divCell" >
				<el-row >
					<el-col>
						<table  class="table">

							<!-- Entête (col0) -->
							<tr v-if="column.col00" v-bind:class="backgroundColorTd" >
								<td class="border-l " v-bind:class="borderR" colspan="3">
									<div v-for="value in column.col00" :key="value.id">
										<checkup-detail v-bind="{checkupDetail:value, textSign:textSign}" />
									</div>
								</td>
							</tr>

							<!-- Titre Signes / Gestes -->
							<tr v-if="parameters.withTitle" v-bind:class="backgroundColor">
								<td colspan="2" class="border-r border-l title2 hidden-sm-and-down">
									<span>Signes</span>
								</td>
								<td colspan="1" class="border-l title2 hidden-md-and-up">
									<span >Signes</span>
								</td>
								<td class="title2 hidden-sm-and-down ">
									<span>Gestes Effectués</span>
								</td>
							</tr>

							<tr v-bind:class="backgroundColorTd" >

								<!-- Colone 1 -->
								<td class="border-l width-td-md" v-bind:class="borderR" >
									<div v-for="value in column.col01" :key="value.id">
										<checkup-detail v-bind="{checkupDetail:value, textSign:textSign}" />
									</div>
								</td>

								<!-- Colone 2 -->
								<td class=" hidden-sm-and-down width-td-md" v-bind:class="borderR">
									<div v-for="value in column.col02" :key="value.id">
										<checkup-detail v-bind:checkupDetail="value" />
									</div>
								</td>

								<!-- Colone 3 -->
								<td class=" hidden-sm-and-down width-td-md">
									<div v-for="value in column.col03" :key="value.id">
										<checkup-detail v-bind:checkupDetail="value" />
									</div>
								</td>
							</tr>

							<!-- Colone 2 (sur une seule ligne pour le mobile) -->
							<tr v-bind:class="backgroundColorTd" class="hidden-md-and-up">
								<td  class="border-l border-r" >
									<div v-for="value in column.col02" :key="value.id">
										<checkup-detail v-bind:checkupDetail="value" />
									</div>
								</td>
							</tr>

							<!-- Titre -->
							<tr v-if="parameters.withTitle" v-bind:class="backgroundColor"  class="hidden-md-and-up">
								<td class="title2 border-l">
									<span>Gestes</span>
								</td>
							</tr>

							<!-- Colone 2 (sur une seule ligne pour le mobile) -->
							<tr v-bind:class="backgroundColorTd" class="hidden-md-and-up">
								<td  class="border-l">
									<div v-for="value in column.col03" :key="value.id">
										<checkup-detail v-bind:checkupDetail="value" />
									</div>
								</td>
							</tr>
						</table>
					</el-col>
				</el-row >
			</div>
		</div>
</template>

<script>
import CheckupDetail from '@/components/checkup.detail.component.vue'

export default {
	name: 'checkupTab',
	props: ['column','parameters','textSign'],
	components: {
		CheckupDetail
	},
	computed: {
		backgroundColor() {
			return this.parameters.classColor;
		},
		backgroundColorTd() {
			return this.parameters.classColor+"-td";
		},
		borderL() {
			return this.parameters.borderLeft;
		},
		borderR() {
			return this.parameters.borderRight;
		}
	}
};

</script>

<style scoped>

	@media only screen and (max-width: 992px) {
		.border-r{
			border-right-style: none;
			border-bottom-width: 6px;
			border-bottom-style: solid;
			border-color: white;
		}
	}

	@media only screen and (max-width: 767px) {   
		.border-l{
			border-left-style: none;
		}
	}

</style>
